import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { unobserve } from './intersection-observer';
import 'next/stylesheets/components/grid/project-progress-row.scss';

Component('tr-grid-project-progress-row', {
  mixins: [eventListenerMixin],

  properties: {
    portfolioManifestId: String,
    detailUrl: String,
    editUrl: String,

    selected: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.listenTo(this, {
      'tao:connected': () => {
        this.namespacedTrigger('afterConnected', { bubbles: true });
      },
      'tao:cellValueChange': this.handleCellValueChange.bind(this),
      click: this.handleClick.bind(this),
    });
  },

  ready() {
    this.gridSubscription = resourceSubject('tr-grid').subscribe({
      next: this.handleGridSubscriptionEvent.bind(this),
    });
  },

  disconnected() {
    unobserve(this, 'tr-grid-project-progress-row');
    this.selected = false;
    this.stopListening();
    if (this.gridSubscription) this.gridSubscription.unsubscribe();
  },

  handleGridSubscriptionEvent(event, payload) {
    if (event === 'columnResized' && payload.syncKey === 'stickyCell') {
      this.updateStickyCellWidth(payload.width);
    }
  },

  handleClick(event) {
    if (closest(event.target, '.more_actions', this)) return;

    const preventClick = Array.from(this.querySelectorAll('[editable]'))
      .some(cell => cell.preventClickEvent(event));
    if (!preventClick) {
      this.namespacedTrigger('click', {
        detail: { originalEvent: event },
        bubbles: true,
      });
    }
  },

  updateStickyCellWidth(width) {
    this.stickyCellStyle = this.stickyCellStyle
      || this.querySelector('.grid-sticky-cell').style;
    this.stickyCellPlaceholderStyle = this.stickyCellPlaceholderStyle
      || this.querySelector('.grid-sticky-cell-placeholder').style;

    this.stickyCellStyle.width = `${width}px`;
    this.stickyCellPlaceholderStyle.width = `${width}px`;
  },

  updateProgress(data) {
    $.ajax({
      url: this.editUrl,
      type: 'put',
      dataType: 'json',
      data,
    });
  },

  handleCellValueChange(event) {
    const { target } = event;
    const { value } = event.detail;
    if (['priority', 'assignee_id'].indexOf(target.key) !== -1) {
      this.updateProgress({ [target.key]: value });
    } else if (target.key === 'due_date') {
      const [startAt, endAt] = this.parseDate(value.split(','));
      this.updateProgress({ start_at: startAt, end_at: endAt });
    } else {
      this.updateProgress({ custom_field_value: { [target.key]: value } });
    }
  },

  parseDate(dates) {
    let startAt;
    let endAt;
    if (dates.length === 2) {
      [startAt, endAt] = dates;
    } else {
      startAt = null;
      [endAt] = dates;
    }
    return [startAt, endAt];
  },
});
